module.exports = __webpack_public_path__ + "media/couriers/gls_logo-8d35f40c.png";